<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>车间列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="90px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="工厂名称" prop="factory_code">
                <el-select v-model="searchform.factory_code" filterable @change="
                  getfactorysubgetsearch(searchform.factory_code),
                  (searchform.factory_sub_code = null)
                  " style="width: 100%" placeholder="请选择工厂">
                  <el-option v-for="(item, index) in factorylist" :key="index" :label="item.factory_name"
                    :value="item.factory_code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="车间编号" prop="workshop_code">
                <el-input v-model="searchform.workshop_code" style="width: 100%" clearable placeholder="请输入车间编号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="车间名称" prop="workshop_name">
                <el-input v-model="searchform.workshop_name" style="width: 100%" clearable placeholder="请输入车间名称" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" style="margin-left: 10px">
              <el-button type="primary" icon="el-icon-search" @click="search"
                v-permission="['workshoplist_select']">搜索</el-button>
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
                v-permission="['workshoplist_add']">新建车间</el-button>
              <el-button v-permission="['workshoplist_export']" :loading="downloadLoading" type="primary"
                icon="document" @click="handleDownload">导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-row type="flex" class="row-bg">
        <el-col :span="24">
          <el-table v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" border style="width: 100%"
            @cell-click="danhang">
            <el-table-column prop="factory_name" label="工厂" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="workshop_code" label="车间编号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="workshop_name" label="车间名称" min-width="100" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="factory_address" label="地址"></el-table-column> -->
            <el-table-column prop="action" label="操作" width="250">
              <el-button-group>
                <el-button type="primary" plain size="mini" @click="update"
                  v-permission="['workshoplist_update']">修改</el-button>
                <el-button type="danger" plain size="mini" @click="deletedata"
                  v-permission="['workshoplist_delete']">删除</el-button>
                <el-button type="primary" plain size="mini" @click="tiaozhuan"
                  v-permission="['workshoplist_link']">产线列表</el-button>
              </el-button-group>
            </el-table-column>
          </el-table>
          <br />
          <!-- 编辑修改出框 -->
          <el-dialog title="编辑" :visible.sync="editVisible" center width="30%" @close="resetForm('form')">
            <el-form :model="form" ref="form" label-width="100px" :rules="rules">
              <el-row>
                <el-form-item label="工厂编号" prop="factory_code">
                  <el-select v-model="form.factory_code" @change="
                    getfactorysubget(form.factory_code),
                    (form.factory_uuid = null)
                    " :disabled="false" style="width: 80%" placeholder="请选择工厂">
                    <el-option v-for="(item, index) in factorylist" :key="index" :label="item.factory_name"
                      :value="item.factory_code"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="车间编号" prop="workshop_code">
                  <el-input v-model="form.workshop_code" style="width: 80%" placeholder="请输入车间编号" />
                </el-form-item>

                <el-form-item label="车间名称" prop="workshop_name">
                  <el-input v-model="form.workshop_name" style="width: 80%" placeholder="请输入车间名称" />
                </el-form-item>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="editVisible = false">取 消</el-button>
              <el-button type="primary" @click="submit('form')">确 定</el-button>
            </span>
          </el-dialog>
          <!-- 新增弹出框 -->
          <el-dialog title="添加" :visible.sync="dialogVisible" @close="resetForm('formadd')" width="28%" :modal="true"
            center>
            <el-form :model="formadd" :rules="rules" ref="formadd" label-width="100px" style="margin-left: 15%">
              <el-row>
                <el-form-item label="工厂编号" prop="factory_code">
                  <el-select v-model="formadd.factory_code" style="width: 80%" placeholder="请选择工厂" @change="
                    getfactorysubget(formadd.factory_code),
                    (formadd.factory_sub_code = null)
                    ">
                    <el-option v-for="(item, index) in factorylist" :key="index" :label="item.factory_name"
                      :value="item.factory_code"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="车间编号" prop="workshop_code">
                  <el-input v-model="formadd.workshop_code" style="width: 80%" placeholder="请输入车间编号" />
                </el-form-item>
                <el-form-item label="车间名称" prop="workshop_name">
                  <el-input v-model="formadd.workshop_name" style="width: 80%" placeholder="请输入车间名称" />
                </el-form-item>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button @click="resetForm('formadd')">重置</el-button>
              <el-button type="primary" @click="submitadd('formadd')">确 定</el-button>
            </span>
          </el-dialog>
          <el-pagination background @current-change="currentchange" @size-change="pagesize"
            :current-page.sync="currentPage" :page-sizes="[10, 20, 50, 100]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
          <el-divider></el-divider>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  workshoplist,
  workshopadd,
  workshopdelete,
  workshopupdate,
  factorylist,
  listdistinct,
} from "@/api/plant";
export default {
  mounted() {
    // 工厂下拉
    listdistinct().then((response) => {
      this.factorylist = response.data;
      for (let i = 0; i < this.factorylist.length; i++) {
        this.factorylist[i].factory_name =
          this.factorylist[i].factory_code +
          "|" +
          this.factorylist[i].factory_name;
      }
    });
    // this.Tabledata()
    this.search();
  },
  data() {
    return {
      // 下拉数据
      factory_type: [
        {
          value: 0,
          label: "外协工厂",
        },
        {
          value: 1,
          label: "自有工厂",
        },
      ],
      //基础数据
      dialogVisible: false,
      editVisible: false,
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      searchform: {
        factory_code: null,
        workshop_uuid: null,
        workshop_code: null,
        workshop_name: null,
        factory_sub_code: null,
        pageSize: 20,
      },
      //获取工厂下拉，post请求
      factory: {
        factory_uuid: null,
        factory_name: null,
        factory_code: null,
        factory_type: -1,
        factory_address: null,
        pageSize: 10000,
      },
      factorylist: [],
      factorysubgetsearch: [],
      factorysubget: [],
      factoryget: [],
      //导出表格变量
      tableDataDownload: [],
      listLoading: true,
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //修改表单数据
      form: {
        factory_code: null,
        workshop_uuid: "",
        workshop_code: "",
        workshop_name: "",
        factory_uuid: "",
      },
      //新增弹窗变量begin
      //表单数据
      formadd: {
        factory_code: null,
        workshop_code: "",
        workshop_name: "",
        factory_uuid: "",
      },
      //基础表单验证
      rules: {
        workshop_name: [
          { required: true, message: "请输入车间名称", trigger: "blur" },
        ],
        factory_code: [
          { required: true, message: "请输入工厂名称", trigger: "blur" },
        ],
        workshop_code: [
          { required: true, message: "请输入车间编号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" },
        ],
      },
    };
  },
  activated() {
    this.searchform.factory_code = this.$route.query.factory_code;
    this.search();
    console.log("11");
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      //请求部门列表数据并且便利到表格
      workshoplist(obj).then((response) => {
        this.tableData = response.data.data;
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].factory_name =
            this.tableData[i].factory_code + this.tableData[i].factory_name;
        }
        this.total_count = response.data.total_count;
        this.currentPage = response.data.page_index;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 工厂自编码下拉
    getfactorysubget(obj) {
      factorylist({ factoryCode: obj }).then((response) => {
        this.formadd.factory_uuid = response.data.data[0].factory_uuid;
        this.form.factory_uuid = response.data.data[0].factory_uuid;
        this.factorysubget = response.data.data;
      });
    },
    getfactorysubgetsearch(obj) {
      factorylist({ factoryCode: obj }).then((response) => {
        this.factorysubgetsearch = response.data.data;
      });
    },
    //新增保存提示
    submitadd(formName) {
      this.$refs[formName].validate((valid) => {
        //基础表单验证
        if (valid) {
          this.dialogVisible = false;
          workshopadd({
            workshop_code: this.formadd.workshop_code,
            factory_uuid: this.formadd.factory_uuid,
            workshop_name: this.formadd.workshop_name,
          }).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!",
              });
              this.resetForm(formName);
              this.search();
              console.log(this.formadd.account_status);
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //搜索事件
    search() {
      workshoplist(this.searchform).then((response) => {
        this.tableData = response.data.data;
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].factory_name =
            this.tableData[i].factory_code + this.tableData[i].factory_name;
        }
        this.total_count = response.data.total_count;
        this.currentPage = response.data.page_index;
        this.listLoading = false;
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.factorysubgetsearch = [];
    },
    //分页跳转事件
    currentchange(pageIndex) {
      this.currentPage = pageIndex;
      this.Tabledata({
        workshop_uuid: this.searchform.workshop_uuid,
        workshop_code: this.searchform.workshop_code,
        workshop_name: this.searchform.workshop_name,
        factory_uuid: this.searchform.factory_uuid,
        pageIndex: this.currentPage,
      });
    },
    //分页每页显示条数事件
    pagesize(page_size) {
      this.searchform.pageSize = page_size;
      this.search();
    },
    //表格单行点击
    danhang(row) {
      this.form.factory_code = row.factory_code;
      this.form.workshop_code = row.workshop_code;
      this.form.workshop_name = row.workshop_name;
      this.form.factory_uuid = row.factory_uuid;
      this.form.workshop_uuid = row.workshop_uuid;
      this.getfactorysubget(row.factory_code);
      console.log(row);
    },
    // 修改弹窗保存       请求接口！！
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        //基础表单验证
        if (valid) {
          this.editVisible = false;
          workshopupdate({
            workshop_uuid: this.form.workshop_uuid,
            workshop_code: this.form.workshop_code,
            factory_uuid: this.form.factory_uuid,
            workshop_name: this.form.workshop_name,
          }).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "修改成功!",
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "修改失败!请检查字段",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改按钮弹窗
    update() {
      setTimeout(() => {
        (this.requestnum = "1"), (this.editVisible = true); //弹窗false关闭 true开启
      }, 150);
    },
    //删除按钮事件
    deletedata() {
      setTimeout(() => {
        this.$confirm("此操作将永久删除该车间信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            workshopdelete({
              workshop_uuid: this.form.workshop_uuid,
            }).then((response) => {
              if (response.status_code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.search();
              } else {
                this.$message({
                  type: "woring",
                  message: "删除失败!请检查字段",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }, 150);
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        factory_code: this.searchform.factory_code,
        workshop_uuid: this.searchform.workshop_uuid,
        workshop_code: this.searchform.workshop_code,
        workshop_name: this.searchform.workshop_name,
        factory_sub_code: this.searchform.factory_sub_code,
      };
      workshoplist(obj).then((response) => {
        this.tableDataDownload = response.data.data;
        for (let i = 0; i < this.tableDataDownload.length; i++) {
          this.tableDataDownload[i].factory_name =
            this.tableDataDownload[i].factory_code +
            this.tableDataDownload[i].factory_name;
        }
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = ["工厂", "车间编号", "车间名称"];
          const filterVal = [
            "factory_name",
            "workshop_code",
            "workshop_name",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      setTimeout(() => {
        this.$router.push({
          path: "/workline",
          query: { workshop_uuid: this.form.workshop_uuid },
        });
        console.log(this.form.factory_code);
      }, 100);
    },
  },
};
</script>
<style scoped></style>
